import { render, staticRenderFns } from "./FinanceBankDetailsPartners.vue?vue&type=template&id=6fded826&"
import script from "./FinanceBankDetailsPartners.vue?vue&type=script&lang=js&"
export * from "./FinanceBankDetailsPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports